import { action } from '@/lib/api';
import pushChangesQueueItem from '@/redux/actions/pushChangesQueueItem';
import { store } from '@/redux/lib/configureStore';
import selectors from '@/redux/selectors/selectors';
import toRecentCompanyPref from '@/lib/toRecentCompanyPref.js';

const setPref = (key, value) => {
  const prefValue = key === 'recentCompanies' ? value.map(toRecentCompanyPref) : value;
  action('uiSetPref', { [key]: prefValue });

  const state = store.getState();
  const userId = selectors.userId(state);
  pushChangesQueueItem('userPref', { userId, path: key, value: prefValue });
};

export default setPref;
